'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var LocalOffer = {};

exports.__exports = LocalOffer;
